import { mapActions, mapGetters } from 'vuex';
import { GcButton, GcDropDown } from '@garmin/components-global';
import Tooltip from '../Tooltip/index.vue';
import { getPartNumberFromUrl } from '../../helpers/parseProductUrl';

export default {
  name: 'EmsFilters',
  components: {
    Tooltip,
    GcButton,
    GcDropDown,
  },
  computed: {
    isDropdown() {
      return this.getFilterDropdownList.length > 0;
    },
    ...mapGetters([
      'getOptionsList',
      'getOptionListByType',
      'getAllOptionItems',
      'getFilterDropdownSelected',
      'getFilterDropdownList',
      'getActiveProductTabs',
    ]),
  },
  methods: {
    setFiltersGaAttr(href) {
      return `EMS - Filter, click, ${href}`;
    },
    setDropdownGaAttr(value) {
      return `EMS - Filter, change, ${value}`;
    },
    ...mapActions([
      'updateProductData',
      'setFilterDropdownSelected',
    ]),
    optionsList() {
      if (this.isDropdown) {
        return this.getOptionsList;
      }
      return this.getOptionListByType('ems');
    },
    getButtons(emsCategory) {
      return this.getAllOptionItems(emsCategory);
    },
    calculateLinkClass(button) {
      return {
        'app__product__filters__buttons--selected': button.selected,
        js__selected: button.selected,
        app__product__filters__buttons: true,
        'js__filter-option': true,
      };
    },
    async changeOption(button) {
      // update the product data
      await this.updateProductData(button.sku);
    },
    async changeDropdown(e) {
      const url = e.target.value;
      const sku = getPartNumberFromUrl(url);

      // if a sku is not found in url, redirect the page to the url
      // this is fallback in case the dropdown value provided doesn't have the sku (bad data)
      if (!sku) {
        window.location.assign(url);
        return;
      }

      this.setFilterDropdownSelected(url);
      await this.updateProductData(sku);
    },
  },
};
